import { html } from 'lit';
const ExportToMarkdown =
  ({ width = '1em', height = '1em', style = '' }: { width?: string, height?: string, style?: string } = {}) =>
    html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${'user-select:none;flex-shrink:0;' + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M8 2.25A2.75 2.75 0 0 0 5.25 5v3a.75.75 0 0 0 1.5 0V5c0-.69.56-1.25 1.25-1.25h7.522c.386 0 .75.178.987.483l2.478 3.186c.17.22.263.49.263.767V18c0 .69-.56 1.25-1.25 1.25H8c-.69 0-1.25-.56-1.25-1.25v-1.5a.75.75 0 0 0-1.5 0V18A2.75 2.75 0 0 0 8 20.75h10A2.75 2.75 0 0 0 20.75 18V8.186a2.75 2.75 0 0 0-.58-1.688l-2.477-3.186a2.75 2.75 0 0 0-2.171-1.062H8M2.769 13.84c0 .337.18.527.496.527.317 0 .497-.19.497-.526v-1.786h.022l.77 1.942c.076.193.207.284.411.284.202 0 .325-.088.403-.284l.77-1.942h.022v1.786c0 .336.18.526.497.526s.497-.19.497-.526v-2.737c0-.478-.263-.746-.738-.746-.4 0-.613.158-.774.58l-.669 1.748h-.021l-.671-1.748c-.162-.422-.374-.58-.774-.58-.475 0-.738.268-.738.746zm4.925-.136c0 .381.207.596.57.596H9.35c1.173 0 1.866-.725 1.866-1.966 0-1.24-.69-1.91-1.866-1.91H8.263c-.362 0-.57.216-.57.597zm1.496-.309h-.357V11.33h.357c.545 0 .867.352.867 1.004 0 .715-.298 1.061-.867 1.061" clip-rule="evenodd"/>
  </svg>
`;
export default ExportToMarkdown;
